/*
 * A regua horizontal do conteudo. Dois papeis, distinguidos pela prop e nao pela posicao:
 * sem `opening` ela divide dois blocos de conteudo e vale em qualquer viewport; com `opening`
 * ela ABRE a coluna esquerda e existe so no mobile, porque no desktop o share ja desenha a
 * propria linha acima de si e o segundo traco fica redundante.
 */
import React from 'react';

interface ISeparatorProps {
    opening?: boolean;
}

const Separator: React.FC<ISeparatorProps> = ({ opening }) => (
    <div
        className={`content-block content-block--separator${
            opening ? ' content-block--separator-opening' : ''
        }`}
    >
        <hr className="separator__rule" />
    </div>
);

export default Separator;
